import { logsConsumerApi } from '@api/logs/logs-consumer.api';

export const { useLazyLoadRequestsQuery, useLazyLoadEventsQuery } = logsConsumerApi;
